import i18n from 'i18next';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import Utils from 'utils/utils';

import s from '../index.module.scss';

export const columns = [
	{
		title: i18n.t('dateText'),
		dataIndex: 'postDate',
		width: 110,
		render: (date: string) => {
			return <Typography.Text>{date} UTC</Typography.Text>;
		},
	},
	{
		title: i18n.t('detailsText'),
		dataIndex: 'type',
		render: (type: string) => {
			return reportTypes[type];
		},
		width: 270,
	},
	{
		title: i18n.t('projectIdFilterText'),
		dataIndex: 'loanId',
		render: (loanId: number) => {
			return loanId ? (
				<Link to={`/account/projects/${loanId}`} className={s.greenText}>
					{loanId}
				</Link>
			) : (
				'-'
			);
		},
		width: 100,
	},
	{
		title: i18n.t('amountText'),
		dataIndex: 'amount',
		width: 100,
		render: (amount: number) => {
			const isNegative = amount < 0;

			return (
				<Typography.Text
					className={classnames({
						[s.redText]: isNegative,
					})}
				>
					{Utils.moneyFormat(+amount)}
				</Typography.Text>
			);
		},
	},
];

const reportTypes: { [key: string]: string } = {
	BUYBACK_INTEREST: i18n.t('amountOfInterestText'),
	BUYBACK_PRINCIPAL: i18n.t('amountOfPrincipalText'),
	COMPENSATION_INTEREST: i18n.t('compensationInterestText'),
	DEPOSIT: i18n.t('depositTransactionText'),
	DEPOSIT_CORRECTION: i18n.t('depositCorrectionText'),
	INVESTMENT: i18n.t('investmentText'),
	INVESTMENT_PURCHASE_DIFF: i18n.t('investmentPurchaseText'),
	INVESTMENT_REFUND: i18n.t('investmentRefundText'),
	INVESTMENT_SALE_DIFF: i18n.t('investmentSaleDifferenceText'),
	INVESTMENT_SALE_FEE: i18n.t('investmentSaleFeeText'),
	REFERRAL_FEE: i18n.t('referralFeeText'),
	REPAYMENT_INTEREST: i18n.t('amountOfInterestText'),
	REPAYMENT_PRINCIPAL: i18n.t('amountOfPrincipalText'),
	TAX_WITHHOLDING: i18n.t('taxWithholdingText'),
	WITHDRAWAL: i18n.t('withdrawalText'),
	WITHDRAWAL_REFUND: i18n.t('withdrawalReturnText'),
};
